import { Directive, HostListener, Input, inject } from '@angular/core';
import { DownloadService } from './download.service';

@Directive({
  selector: '[sharedDownload]',
  standalone: true,
})
export class DownloadDirective {
  private _downloadService = inject(DownloadService);
  @Input() sharedDownload: { name: string; source: string };

  @HostListener('click')
  download(): void {
    return this._downloadService.download(this.sharedDownload);
  }
}
